const initCollapsible = () => {
  const questions = document.querySelectorAll('.question');
  if(questions.length > 0) {
    questions.forEach(function (question) {
      const collapsible = question.closest('.collapsible');
      if(collapsible){
        const answer = collapsible.querySelector('.answer');
        const openIcon = collapsible.querySelector('.open');
        const closeIcon = collapsible.querySelector('.close');
        const noRedText = collapsible.dataset.noRedText;

        collapsible.addEventListener('click', function () {
          if (question.classList.contains('closed')) {
            openIcon.classList.add('hidden');
            closeIcon.classList.remove('hidden');
            answer.classList.remove('hidden');

            question.classList.remove('closed');
            question.classList.add('opened');

            noRedText == 'true' ? question.classList.add("font-semibold") : question.classList.add("text-red");
          } else if (question.classList.contains('opened')) {
            openIcon.classList.remove('hidden');
            closeIcon.classList.add('hidden');
            answer.classList.add('hidden');

            question.classList.remove('opened');
            question.classList.add('closed');

            noRedText == 'true' ? question.classList.remove("font-semibold") : question.classList.remove("text-red");
          }
        });

        //add in JS here so users with no JS see answers
        answer.classList.add('hidden');
      }
    });
  }
}

export { initCollapsible }
